var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGust01 = function SvgGust01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gust-01_svg2__a",
    x1: 32.54,
    x2: 437.54,
    y1: 416.34,
    y2: 84.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#gust-01_svg2__a",
    id: "gust-01_svg2__b",
    x1: 54.22,
    x2: 459.22,
    y1: 442.78,
    y2: 110.78
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#gust-01_svg2__a",
    id: "gust-01_svg2__c",
    x1: 131.68,
    x2: 536.68,
    y1: 537.28,
    y2: 205.28
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#gust-01_svg2__a",
    id: "gust-01_svg2__d",
    x1: 107.79,
    x2: 512.79,
    y1: 508.13,
    y2: 176.13
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M380.81 340.8c-2.52 0-5-1.19-6.56-3.41-2.53-3.62-1.65-8.61 1.97-11.14 7.8-5.46 13.71-11.81 17.56-18.88a7.995 7.995 0 0 1 10.6-3.32c8.55 4.28 17.85 6.36 28.42 6.36 35.29 0 64-28.71 64-64 0-32.42-24.12-59.62-56.1-63.25-4.38-.5-7.54-4.45-7.05-8.83l.22-1.95c.72-6.37 1.33-11.86 1.33-17.96-.75-67.01-56.01-121.6-123.2-121.6-45.77 0-87.19 25.02-108.1 65.29-1.04 2-2.87 3.46-5.04 4.04s-4.49.22-6.38-1c-10.1-6.5-22.16-9.93-34.87-9.93-34.85 0-63.2 28.35-63.2 63.2 0 6.29 1.11 12.42 3.59 19.87.94 2.82.24 5.92-1.81 8.06a8.02 8.02 0 0 1-7.98 2.16c-4.86-1.39-9.77-2.09-14.6-2.09-32.2 0-58.4 26.2-58.4 58.4s24.49 56.29 55.74 58.42c4.41.3 7.74 4.12 7.44 8.53a8 8 0 0 1-8.53 7.44C30.24 312.48-.8 279.81-.8 240.8c0-19.94 7.72-38.64 21.74-52.66S53.66 166.4 73.6 166.4c1.96 0 3.94.09 5.91.26a68.8 68.8 0 0 1-1.11-12.26c0-43.67 35.53-79.2 79.2-79.2 12.82 0 25.15 2.84 36.13 8.28C218.44 42.14 263.02 16.8 312 16.8c36.95 0 71.73 14.24 97.92 40.11 26.21 25.88 40.87 60.47 41.28 97.4 0 5.05-.35 9.65-.82 14.25 16.06 3.52 30.74 12.08 41.98 24.6 13.18 14.69 20.45 33.6 20.45 53.24 0 21.48-8.29 41.6-23.34 56.66-15.05 15.05-35.17 23.34-56.66 23.34-10.46 0-19.98-1.67-28.9-5.1-4.76 6.71-10.96 12.76-18.52 18.05-1.4.98-3 1.45-4.58 1.45",
    style: {
      fill: "url(#gust-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.8 333.6H90.4c-4.42 0-8-3.58-8-8s3.58-8 8-8h198.4c18.65 0 34.4-15.75 34.4-34.4s-15.75-34.4-34.4-34.4-34.4 15.75-34.4 34.4c0 4.42-3.58 8-8 8s-8-3.58-8-8c0-27.79 22.61-50.4 50.4-50.4s50.4 22.61 50.4 50.4-22.61 50.4-50.4 50.4",
    style: {
      fill: "url(#gust-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.8 457.6c-27.79 0-50.4-22.61-50.4-50.4 0-4.42 3.58-8 8-8s8 3.58 8 8c0 18.65 15.75 34.4 34.4 34.4s34.4-15.75 34.4-34.4-15.75-34.4-34.4-34.4h-212c-4.42 0-8-3.58-8-8s3.58-8 8-8h212c27.79 0 50.4 22.61 50.4 50.4s-22.61 50.4-50.4 50.4",
    style: {
      fill: "url(#gust-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.6 495.2c-26.92 0-48-21.08-48-48 0-4.42 3.58-8 8-8s8 3.58 8 8c0 17.94 14.06 32 32 32s32-14.06 32-32-14.06-32-32-32H80c-4.42 0-8-3.58-8-8s3.58-8 8-8h189.6c26.92 0 48 21.08 48 48s-21.08 48-48 48",
    style: {
      fill: "url(#gust-01_svg2__d)"
    }
  }));
};
export default SvgGust01;